export enum ReviewerRole {
    Unknown = 0,
    LeadReviewer = 1,
    SecondaryReviewer = 2,
    QualityAssurer = 3,
    QualityAssuranceManager = 4
}
